import React from 'react'
import IrregularInteraction from '../../IrregularInteraction'
import ItemImage from '../../ItemImage'
import image from '../../../assets/images/bedroom/item--switch@3x.png'

const points =
  '0.01 23.45 0 0.33 0.71 0 12.14 6.58 12.14 29.65 11.41 30.02 0.01 23.45'

const Switch = props => (
  <IrregularInteraction
    points={points}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 12.14 30.02"
    sparksTop={-153}
    sparksLeft={-173}
    sparksRotation={182}
    sparksPercentWidth="200%"
    {...props}
  >
    <ItemImage src={image} />
  </IrregularInteraction>
)

Switch.propTypes = IrregularInteraction.propTypes

export default Switch



// WEBPACK FOOTER //
// ./src/components/items/bedroom/Switch.js